import { Client } from "./client";

export enum Role {
  ADMIN = "ADMIN",
  USER = "USER",
  FIRMADMIN = "FIRMADMIN",
  ADVISOR = "ADVISOR",
  ASSISTANT = "ASSISTANT",
}

export type RoleAssignment = {
  userId: string;
  role: Role;
};

export enum SettingType {
  ADHOC = "ADHOC",
  HOSTONLY = "HOSTONLY",
  EXTERNAL = "EXTERNAL",
  ALL = "ALL",
}

export type User = {
  id: string;
  email: string;
  firstname: string;
  lastname: string;
  phone?: string | null;
  firmId: string;
  crmUserId?: string;
  email_verified: boolean;
  createdAt: number;
  updatedAt: number;
  locked: boolean;
  deletedAt?: number | null;
  roles: RoleAssignment[];
  Client: Client[];
};

export type Setting = {
  userId: string;
  setting: SettingType;
};
